import QuestionAndAnswersService from "@/services/questionsAndAnswers.js";
import serviceHandler from "@/helpers/handlers/service";

export default {
  async getQuestions({ commit }, params) {
    const { results, count } = await serviceHandler(
      QuestionAndAnswersService.getQuestions(params)
    );
    commit("SET_QUESTIONS", results);
    commit("SET_TOTAL_COUNT", count);
  },
  async createQuestions({ commit }, { question, answer }) {
    const questionResult = await serviceHandler(
      QuestionAndAnswersService.createQuestion(question)
    );
    await serviceHandler(
      QuestionAndAnswersService.createAnswerByQuestionId(
        questionResult.id,
        answer
      )
    );
  },
  async deleteQuestion({ commit }, { parentId, elementId }) {
    commit("DELETE_LIST_ITEM", { parentId, elementId });
  }
};
